import { Link, useLocation } from 'react-router-dom';
import { useOnline } from '../lib/offline';
import { offlineSupported } from '../lib/offline-store';

/**
 * Dezenter Streifen am oberen Rand, solange das Gerät kein Netz hat: Was offline gespeichert ist, bleibt
 * zugänglich; Änderungen brauchen Netz (sie melden das beim Versuch verständlich).
 */
export function OfflineBanner(): JSX.Element | null {
  const online = useOnline();
  const { pathname } = useLocation();
  if (online) return null;
  const hier = pathname.startsWith('/offline');
  return (
    <div role="status" data-testid="offline-banner" className="border-b border-amber-200 bg-amber-50 px-4 py-1.5 text-xs text-amber-900 print:hidden">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-between gap-x-3 gap-y-1">
        <span>
          {offlineSupported() ? 'Offline – gespeicherte Einheiten verfügbar' : 'Offline – ohne Netz geht hier nichts'}
          <span className="hidden sm:inline"> · Ändern geht nur mit Netz</span>
        </span>
        {offlineSupported() && !hier && (
          <Link to="/offline" className="font-semibold underline">Offline gespeichert öffnen</Link>
        )}
      </div>
    </div>
  );
}
